module.exports = __webpack_public_path__ + "img/lock_white_background.41c6b8fc.svg";